export const formatSAR = (value: number): string =>
  `${value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ر.س`;

export const formatNumber = (value: number): string =>
  value.toLocaleString("en-US");